import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../wayfinder'
import filter from './filter'
import labels from './labels'
import marriageChildren from './marriage-children'
/**
* @see \App\Http\Controllers\Gallery\NodeGalleryPhotoController::__invoke
* @see app/Http/Controllers/Gallery/NodeGalleryPhotoController.php:18
* @route '/user/nodes/{node}/gallery-photos'
*/
export const galleryPhotos = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: galleryPhotos.url(args, options),
    method: 'get',
})

galleryPhotos.definition = {
    methods: ["get","head"],
    url: '/user/nodes/{node}/gallery-photos',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Gallery\NodeGalleryPhotoController::__invoke
* @see app/Http/Controllers/Gallery/NodeGalleryPhotoController.php:18
* @route '/user/nodes/{node}/gallery-photos'
*/
galleryPhotos.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return galleryPhotos.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Gallery\NodeGalleryPhotoController::__invoke
* @see app/Http/Controllers/Gallery/NodeGalleryPhotoController.php:18
* @route '/user/nodes/{node}/gallery-photos'
*/
galleryPhotos.get = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: galleryPhotos.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Gallery\NodeGalleryPhotoController::__invoke
* @see app/Http/Controllers/Gallery/NodeGalleryPhotoController.php:18
* @route '/user/nodes/{node}/gallery-photos'
*/
galleryPhotos.head = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: galleryPhotos.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\NodeContentController::__invoke
* @see app/Http/Controllers/Tenant/NodeContentController.php:17
* @route '/user/nodes/{node}/content'
*/
export const content = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: content.url(args, options),
    method: 'get',
})

content.definition = {
    methods: ["get","head"],
    url: '/user/nodes/{node}/content',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\NodeContentController::__invoke
* @see app/Http/Controllers/Tenant/NodeContentController.php:17
* @route '/user/nodes/{node}/content'
*/
content.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return content.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\NodeContentController::__invoke
* @see app/Http/Controllers/Tenant/NodeContentController.php:17
* @route '/user/nodes/{node}/content'
*/
content.get = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: content.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\NodeContentController::__invoke
* @see app/Http/Controllers/Tenant/NodeContentController.php:17
* @route '/user/nodes/{node}/content'
*/
content.head = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: content.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\NodeActivityController::__invoke
* @see app/Http/Controllers/Tenant/NodeActivityController.php:18
* @route '/user/nodes/{node}/activities'
*/
export const activities = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: activities.url(args, options),
    method: 'get',
})

activities.definition = {
    methods: ["get","head"],
    url: '/user/nodes/{node}/activities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\NodeActivityController::__invoke
* @see app/Http/Controllers/Tenant/NodeActivityController.php:18
* @route '/user/nodes/{node}/activities'
*/
activities.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return activities.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\NodeActivityController::__invoke
* @see app/Http/Controllers/Tenant/NodeActivityController.php:18
* @route '/user/nodes/{node}/activities'
*/
activities.get = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: activities.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\NodeActivityController::__invoke
* @see app/Http/Controllers/Tenant/NodeActivityController.php:18
* @route '/user/nodes/{node}/activities'
*/
activities.head = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: activities.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\NodeLineSummaryController::__invoke
* @see app/Http/Controllers/Tenant/NodeLineSummaryController.php:19
* @route '/user/nodes/{node}/line-summary'
*/
export const lineSummary = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: lineSummary.url(args, options),
    method: 'get',
})

lineSummary.definition = {
    methods: ["get","head"],
    url: '/user/nodes/{node}/line-summary',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\NodeLineSummaryController::__invoke
* @see app/Http/Controllers/Tenant/NodeLineSummaryController.php:19
* @route '/user/nodes/{node}/line-summary'
*/
lineSummary.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return lineSummary.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\NodeLineSummaryController::__invoke
* @see app/Http/Controllers/Tenant/NodeLineSummaryController.php:19
* @route '/user/nodes/{node}/line-summary'
*/
lineSummary.get = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: lineSummary.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\NodeLineSummaryController::__invoke
* @see app/Http/Controllers/Tenant/NodeLineSummaryController.php:19
* @route '/user/nodes/{node}/line-summary'
*/
lineSummary.head = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: lineSummary.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeSearchExplainedController::__invoke
* @see app/Http/Controllers/Tenant/Branch/NodeSearchExplainedController.php:20
* @route '/nodes/user/search-explained'
*/
export const searchExplained = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: searchExplained.url(options),
    method: 'get',
})

searchExplained.definition = {
    methods: ["get","head"],
    url: '/nodes/user/search-explained',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeSearchExplainedController::__invoke
* @see app/Http/Controllers/Tenant/Branch/NodeSearchExplainedController.php:20
* @route '/nodes/user/search-explained'
*/
searchExplained.url = (options?: RouteQueryOptions) => {
    return searchExplained.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeSearchExplainedController::__invoke
* @see app/Http/Controllers/Tenant/Branch/NodeSearchExplainedController.php:20
* @route '/nodes/user/search-explained'
*/
searchExplained.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: searchExplained.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeSearchExplainedController::__invoke
* @see app/Http/Controllers/Tenant/Branch/NodeSearchExplainedController.php:20
* @route '/nodes/user/search-explained'
*/
searchExplained.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: searchExplained.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeSummariesController::__invoke
* @see app/Http/Controllers/Tenant/Branch/NodeSummariesController.php:14
* @route '/user/nodes/summaries'
*/
export const summaries = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: summaries.url(options),
    method: 'get',
})

summaries.definition = {
    methods: ["get","head"],
    url: '/user/nodes/summaries',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeSummariesController::__invoke
* @see app/Http/Controllers/Tenant/Branch/NodeSummariesController.php:14
* @route '/user/nodes/summaries'
*/
summaries.url = (options?: RouteQueryOptions) => {
    return summaries.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeSummariesController::__invoke
* @see app/Http/Controllers/Tenant/Branch/NodeSummariesController.php:14
* @route '/user/nodes/summaries'
*/
summaries.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: summaries.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeSummariesController::__invoke
* @see app/Http/Controllers/Tenant/Branch/NodeSummariesController.php:14
* @route '/user/nodes/summaries'
*/
summaries.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: summaries.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\OtherParentChildrenController::__invoke
* @see app/Http/Controllers/Tenant/Branch/OtherParentChildrenController.php:16
* @route '/user/nodes/{node}/other-parent-children'
*/
export const otherParentChildren = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: otherParentChildren.url(args, options),
    method: 'get',
})

otherParentChildren.definition = {
    methods: ["get","head"],
    url: '/user/nodes/{node}/other-parent-children',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\OtherParentChildrenController::__invoke
* @see app/Http/Controllers/Tenant/Branch/OtherParentChildrenController.php:16
* @route '/user/nodes/{node}/other-parent-children'
*/
otherParentChildren.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return otherParentChildren.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\OtherParentChildrenController::__invoke
* @see app/Http/Controllers/Tenant/Branch/OtherParentChildrenController.php:16
* @route '/user/nodes/{node}/other-parent-children'
*/
otherParentChildren.get = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: otherParentChildren.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\OtherParentChildrenController::__invoke
* @see app/Http/Controllers/Tenant/Branch/OtherParentChildrenController.php:16
* @route '/user/nodes/{node}/other-parent-children'
*/
otherParentChildren.head = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: otherParentChildren.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeController::index
* @see app/Http/Controllers/Tenant/Branch/NodeController.php:28
* @route '/user/nodes'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/user/nodes',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeController::index
* @see app/Http/Controllers/Tenant/Branch/NodeController.php:28
* @route '/user/nodes'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeController::index
* @see app/Http/Controllers/Tenant/Branch/NodeController.php:28
* @route '/user/nodes'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeController::index
* @see app/Http/Controllers/Tenant/Branch/NodeController.php:28
* @route '/user/nodes'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeController::show
* @see app/Http/Controllers/Tenant/Branch/NodeController.php:51
* @route '/user/nodes/{node}'
*/
export const show = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/user/nodes/{node}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeController::show
* @see app/Http/Controllers/Tenant/Branch/NodeController.php:51
* @route '/user/nodes/{node}'
*/
show.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return show.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeController::show
* @see app/Http/Controllers/Tenant/Branch/NodeController.php:51
* @route '/user/nodes/{node}'
*/
show.get = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeController::show
* @see app/Http/Controllers/Tenant/Branch/NodeController.php:51
* @route '/user/nodes/{node}'
*/
show.head = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeController::destroy
* @see app/Http/Controllers/Tenant/Branch/NodeController.php:127
* @route '/user/nodes/{node}'
*/
export const destroy = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/user/nodes/{node}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeController::destroy
* @see app/Http/Controllers/Tenant/Branch/NodeController.php:127
* @route '/user/nodes/{node}'
*/
destroy.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return destroy.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeController::destroy
* @see app/Http/Controllers/Tenant/Branch/NodeController.php:127
* @route '/user/nodes/{node}'
*/
destroy.delete = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\CreateBulkNodeController::__invoke
* @see app/Http/Controllers/Tenant/Branch/CreateBulkNodeController.php:14
* @route '/user/nodes/{node}/bulk-create'
*/
export const bulkCreate = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bulkCreate.url(args, options),
    method: 'get',
})

bulkCreate.definition = {
    methods: ["get","head"],
    url: '/user/nodes/{node}/bulk-create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\CreateBulkNodeController::__invoke
* @see app/Http/Controllers/Tenant/Branch/CreateBulkNodeController.php:14
* @route '/user/nodes/{node}/bulk-create'
*/
bulkCreate.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return bulkCreate.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\CreateBulkNodeController::__invoke
* @see app/Http/Controllers/Tenant/Branch/CreateBulkNodeController.php:14
* @route '/user/nodes/{node}/bulk-create'
*/
bulkCreate.get = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bulkCreate.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\CreateBulkNodeController::__invoke
* @see app/Http/Controllers/Tenant/Branch/CreateBulkNodeController.php:14
* @route '/user/nodes/{node}/bulk-create'
*/
bulkCreate.head = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: bulkCreate.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeTransferController::transfer
* @see app/Http/Controllers/Tenant/Branch/NodeTransferController.php:19
* @route '/user/nodes/{node}/transfer'
*/
export const transfer = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: transfer.url(args, options),
    method: 'post',
})

transfer.definition = {
    methods: ["post"],
    url: '/user/nodes/{node}/transfer',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeTransferController::transfer
* @see app/Http/Controllers/Tenant/Branch/NodeTransferController.php:19
* @route '/user/nodes/{node}/transfer'
*/
transfer.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return transfer.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeTransferController::transfer
* @see app/Http/Controllers/Tenant/Branch/NodeTransferController.php:19
* @route '/user/nodes/{node}/transfer'
*/
transfer.post = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: transfer.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeOrderController::__invoke
* @see app/Http/Controllers/Tenant/Branch/NodeOrderController.php:20
* @route '/user/nodes/{node}/order'
*/
export const order = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: order.url(args, options),
    method: 'post',
})

order.definition = {
    methods: ["post"],
    url: '/user/nodes/{node}/order',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeOrderController::__invoke
* @see app/Http/Controllers/Tenant/Branch/NodeOrderController.php:20
* @route '/user/nodes/{node}/order'
*/
order.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return order.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeOrderController::__invoke
* @see app/Http/Controllers/Tenant/Branch/NodeOrderController.php:20
* @route '/user/nodes/{node}/order'
*/
order.post = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: order.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeRootController::makeRoot
* @see app/Http/Controllers/Tenant/Branch/NodeRootController.php:32
* @route '/user/nodes/{node}/make-root'
*/
export const makeRoot = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: makeRoot.url(args, options),
    method: 'post',
})

makeRoot.definition = {
    methods: ["post"],
    url: '/user/nodes/{node}/make-root',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeRootController::makeRoot
* @see app/Http/Controllers/Tenant/Branch/NodeRootController.php:32
* @route '/user/nodes/{node}/make-root'
*/
makeRoot.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return makeRoot.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeRootController::makeRoot
* @see app/Http/Controllers/Tenant/Branch/NodeRootController.php:32
* @route '/user/nodes/{node}/make-root'
*/
makeRoot.post = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: makeRoot.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeLineageSpliceController::lineageSplice
* @see app/Http/Controllers/Tenant/Branch/NodeLineageSpliceController.php:27
* @route '/user/nodes/{node}/lineage-splice'
*/
export const lineageSplice = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: lineageSplice.url(args, options),
    method: 'post',
})

lineageSplice.definition = {
    methods: ["post"],
    url: '/user/nodes/{node}/lineage-splice',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeLineageSpliceController::lineageSplice
* @see app/Http/Controllers/Tenant/Branch/NodeLineageSpliceController.php:27
* @route '/user/nodes/{node}/lineage-splice'
*/
lineageSplice.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return lineageSplice.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeLineageSpliceController::lineageSplice
* @see app/Http/Controllers/Tenant/Branch/NodeLineageSpliceController.php:27
* @route '/user/nodes/{node}/lineage-splice'
*/
lineageSplice.post = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: lineageSplice.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\BulkNodeController::bulkStore
* @see app/Http/Controllers/Tenant/Branch/BulkNodeController.php:22
* @route '/user/nodes/bulk-store'
*/
export const bulkStore = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkStore.url(options),
    method: 'post',
})

bulkStore.definition = {
    methods: ["post"],
    url: '/user/nodes/bulk-store',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\BulkNodeController::bulkStore
* @see app/Http/Controllers/Tenant/Branch/BulkNodeController.php:22
* @route '/user/nodes/bulk-store'
*/
bulkStore.url = (options?: RouteQueryOptions) => {
    return bulkStore.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\BulkNodeController::bulkStore
* @see app/Http/Controllers/Tenant/Branch/BulkNodeController.php:22
* @route '/user/nodes/bulk-store'
*/
bulkStore.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkStore.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\VoiceFamilyProposalController::voiceFamilyProposals
* @see app/Http/Controllers/Tenant/Branch/VoiceFamilyProposalController.php:18
* @route '/user/nodes/{node}/voice-family-proposals'
*/
export const voiceFamilyProposals = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: voiceFamilyProposals.url(args, options),
    method: 'post',
})

voiceFamilyProposals.definition = {
    methods: ["post"],
    url: '/user/nodes/{node}/voice-family-proposals',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\VoiceFamilyProposalController::voiceFamilyProposals
* @see app/Http/Controllers/Tenant/Branch/VoiceFamilyProposalController.php:18
* @route '/user/nodes/{node}/voice-family-proposals'
*/
voiceFamilyProposals.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return voiceFamilyProposals.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\VoiceFamilyProposalController::voiceFamilyProposals
* @see app/Http/Controllers/Tenant/Branch/VoiceFamilyProposalController.php:18
* @route '/user/nodes/{node}/voice-family-proposals'
*/
voiceFamilyProposals.post = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: voiceFamilyProposals.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\VoiceFamilyStoreController::bulkTreeStore
* @see app/Http/Controllers/Tenant/Branch/VoiceFamilyStoreController.php:20
* @route '/user/nodes/bulk-tree-store'
*/
export const bulkTreeStore = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkTreeStore.url(options),
    method: 'post',
})

bulkTreeStore.definition = {
    methods: ["post"],
    url: '/user/nodes/bulk-tree-store',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\VoiceFamilyStoreController::bulkTreeStore
* @see app/Http/Controllers/Tenant/Branch/VoiceFamilyStoreController.php:20
* @route '/user/nodes/bulk-tree-store'
*/
bulkTreeStore.url = (options?: RouteQueryOptions) => {
    return bulkTreeStore.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\VoiceFamilyStoreController::bulkTreeStore
* @see app/Http/Controllers/Tenant/Branch/VoiceFamilyStoreController.php:20
* @route '/user/nodes/bulk-tree-store'
*/
bulkTreeStore.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkTreeStore.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\SendNewbornNotificationController::__invoke
* @see app/Http/Controllers/Tenant/Branch/SendNewbornNotificationController.php:14
* @route '/user/nodes/{node}/send-newborn-notification'
*/
export const sendNewbornNotification = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sendNewbornNotification.url(args, options),
    method: 'post',
})

sendNewbornNotification.definition = {
    methods: ["post"],
    url: '/user/nodes/{node}/send-newborn-notification',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\SendNewbornNotificationController::__invoke
* @see app/Http/Controllers/Tenant/Branch/SendNewbornNotificationController.php:14
* @route '/user/nodes/{node}/send-newborn-notification'
*/
sendNewbornNotification.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return sendNewbornNotification.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\SendNewbornNotificationController::__invoke
* @see app/Http/Controllers/Tenant/Branch/SendNewbornNotificationController.php:14
* @route '/user/nodes/{node}/send-newborn-notification'
*/
sendNewbornNotification.post = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sendNewbornNotification.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeController::update
* @see app/Http/Controllers/Tenant/Branch/NodeController.php:87
* @route '/user/nodes/{node}'
*/
export const update = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: update.url(args, options),
    method: 'post',
})

update.definition = {
    methods: ["post"],
    url: '/user/nodes/{node}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeController::update
* @see app/Http/Controllers/Tenant/Branch/NodeController.php:87
* @route '/user/nodes/{node}'
*/
update.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return update.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeController::update
* @see app/Http/Controllers/Tenant/Branch/NodeController.php:87
* @route '/user/nodes/{node}'
*/
update.post = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: update.url(args, options),
    method: 'post',
})

const nodes = {
    galleryPhotos: Object.assign(galleryPhotos, galleryPhotos),
    content: Object.assign(content, content),
    activities: Object.assign(activities, activities),
    lineSummary: Object.assign(lineSummary, lineSummary),
    filter: Object.assign(filter, filter),
    searchExplained: Object.assign(searchExplained, searchExplained),
    labels: Object.assign(labels, labels),
    makeRoot: Object.assign(makeRoot, makeRoot),
    lineageSplice: Object.assign(lineageSplice, lineageSplice),
    summaries: Object.assign(summaries, summaries),
    otherParentChildren: Object.assign(otherParentChildren, otherParentChildren),
    marriageChildren: Object.assign(marriageChildren, marriageChildren),
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    destroy: Object.assign(destroy, destroy),
    bulkCreate: Object.assign(bulkCreate, bulkCreate),
    transfer: Object.assign(transfer, transfer),
    order: Object.assign(order, order),
    bulkStore: Object.assign(bulkStore, bulkStore),
    voiceFamilyProposals: Object.assign(voiceFamilyProposals, voiceFamilyProposals),
    bulkTreeStore: Object.assign(bulkTreeStore, bulkTreeStore),
    sendNewbornNotification: Object.assign(sendNewbornNotification, sendNewbornNotification),
    update: Object.assign(update, update),
}

export default nodes